import { Expense, ExpenseStatusEnum } from "@finway-group/shared/lib/models"
import { GobdExpenseValidationFields } from "@finway-group/shared/lib/models/expense/gobd.expense.types"
import { ExpenseGobdComplianceRules } from "@finway-group/shared/lib/utils/gobdInvoiceCompliance.utils"

export const diagnoseExpenseForGobdCompliance = (expense: Expense): GobdExpenseValidationFields => ({
    status: !!ExpenseGobdComplianceRules.isExpenseStatusReadyForGobdCompliantInvoice(expense.status),
    invoiceDate: !!ExpenseGobdComplianceRules.isInvoiceDateCompliant(expense.invoiceDate),
    invoiceNumber: !!ExpenseGobdComplianceRules.isInvoiceNumberCompliant(expense.invoiceNumber),
    bookingText: !!ExpenseGobdComplianceRules.isBookingTextCompliant(expense.description),
    postingPeriod: !!ExpenseGobdComplianceRules.isPostingPeriodCompliant(expense.postingPeriod),
    amounts: !!ExpenseGobdComplianceRules.isAmountGobdInvoiceCompliant(expense, expense.splits, {
        splitManuallyAdjusted: expense.splitManuallyAdjusted,
        splitType: expense.splitType,
    }),
    vat: !!ExpenseGobdComplianceRules.isVatGobdInvoiceCompliant(expense.splits),
    vendor: !!ExpenseGobdComplianceRules.isVendorGobdCompliant(expense),
    expenseAccount: !!ExpenseGobdComplianceRules.isExpenseAccountCompliant(expense.splits),
})

export const isExpenseGobdInvoiceCompliant = (expense: Expense) => {
    if (expense.gobdInvoiceComplianceDate) {
        return true
    }
    const requirements = diagnoseExpenseForGobdCompliance(expense)
    return Object.values(requirements).every((v) => v)
}

export const willUpdateFlagExpenseAsGobdCompliantInvoice = ({ oldExpenseState, newExpenseState }: { oldExpenseState: Expense; newExpenseState: Expense }) =>
    !oldExpenseState.gobdInvoiceComplianceDate && isExpenseGobdInvoiceCompliant(newExpenseState)

export const willReviewFlagExpenseAsGobdCompliantInvoice = (expense: Expense) => {
    const expenseToTest = new Expense({ ...expense, status: ExpenseStatusEnum.REVIEWED })
    return willUpdateFlagExpenseAsGobdCompliantInvoice({ oldExpenseState: expense, newExpenseState: expenseToTest })
}
